var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.promoConfig)?_c('div',{class:['promo-banner', { 'navbar-hidden': _vm.hiddenNavbar }]},[_c('blw-icon',{staticClass:"mr-3",attrs:{"icon":_vm.promoConfig.icon}}),_c('span',{staticClass:"paragraph-2",domProps:{"innerHTML":_vm._s(_vm.promoConfig.content)}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }